export default {
  title: 'Deliverect',
  form: {
    channel_link_id: {
      label: 'ID link canal: ',
    },
    store_id: {
      label: 'ID locație externă: ',
    },
    store_provisioning_url: {
      label: 'URL provizionare magazin: ',
    },
  },
  buttons: {
    save: 'Salvați',
  },
  toasts: {
    error: 'Salvarea modificărilor a eșuat',
    success: 'Modificările au fost salvate',
  },
  instructions: {
    title: 'Instrucțiuni de configurare:',
    step_1:
      'Deschideți pagina <Link>„Locations"</Link> în Deliverect, extindeți locația corespunzătoare și faceți clic pe butonul „+ Channel link".',
    step_2:
      'Completați informațiile necesare. La pasul „Select your online delivery platform" selectați „Food Amigos".',
    step_3: 'Finalizați toți pașii. Apoi, pe pagina „Locations", faceți clic pe „Edit" la canalul „Food Amigos".',
    step_4: 'În bara laterală faceți clic pe fila „Channel connection" și completați aceste detalii:',
    step_5: 'Salvați modificările făcând clic pe butonul „Save" din dreapta sus.',
    step_6:
      'După salvare, faceți clic pe pictograma „More" din dreapta sus, apoi pe „Register" și după aceea pe „Activate".',
    step_7: 'Reveniți la fila „General", comutați „Integration status" la „Active" și salvați modificările.',
    outro: 'După aceea puteți trimite meniul din Deliverect și crea o comandă de test.',
  },
  connected: {
    title: 'Deliverect este conectat',
    description: 'Această integrare este configurată.',
  },
};
